import { useRef, useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function AudioPreviewModal({ onClose, audio }) {
  const audioRef = useRef(null);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
    };
  }, []);

  return (
    <div className="w-full h-full flex items-center justify-center relative">
      <audio ref={audioRef} src={audio.url} autoPlay controls />
      <button
        type="button"
        onClick={() => onClose(null)}
        className="absolute top-4 right-4 z-10 p-2 rounded-md text-secondary-foreground hover:bg-secondary/60 cursor-pointer"
        title="Close">
        <FiX className="w-7 h-7" />
      </button>
    </div>
  );
}
